import { Search } from '@domain-group/suit-theme'

import type { CampaignQuoteTemplateSectionModel } from '@models/types'

import searchFn from '@functions/search'

const mapResults = (results: CampaignQuoteTemplateSectionModel[]) => {
  if (!results.length){
    return {}
  }

  const groups = [{
    items: results.map((result: CampaignQuoteTemplateSectionModel) => {
      const {
        id,
        title,
      } = result

      return {
        ...result,
        key: id,
        text: title,
      }
    }),
    key: 'sections',
    title: 'Sections',
  }]

  const mapped = {
    groups,
  }

  return mapped
}

interface CampaignQuoteTemplateSectionSearchProps {
  callbacks: {
    onChange: (value: string) => void,
    selectItem: (item: CampaignQuoteTemplateSectionModel) => void,
  },
  value: string,
}

const CampaignQuoteTemplateSectionSearch = (props: CampaignQuoteTemplateSectionSearchProps) => {
  const {
    callbacks: {
      onChange,
      selectItem,
    },
    value,
  } = props

  return (
    <Search
      callbacks={{
        onChange,
        // @ts-expect-error TS2322
        search: searchFn,
        // @ts-expect-error TS2322
        selectItem,
        // @ts-expect-error TS2322
        mapResults,
      }}
      endpoint="campaign_quote_template_sections.json"
      forwardProps={{
        closeOnSelect: true,
        filterItems: false,
        setStringOnSelect: true,
        showOnFocus: true,
      }}
      requestOptions={{ distinct_on_title: 'true' }}
      value={value}
    />
  )
}

export default CampaignQuoteTemplateSectionSearch
